export type SimulationComparaisonWidgetViewState = "idle" | "submitting" | "success" | "error";

export const SIMULATION_COMPARAISON_FORM_STEPS = [
  "intro",
  "bien",
  "options",
  "contact",
  "result",
] as const;
export type SimulationComparaisonFormStep = (typeof SIMULATION_COMPARAISON_FORM_STEPS)[number];

export interface RegimeResultModel {
  revenus_imposables: number;
  impots: number;
  cashflow_net_impot: number;
  cashflow_net_impot_sans_remboursement_capital: number;
}

export type SimulationComparaisonRegimeKey = "lmnp_reel" | "lmnp_micro" | "nu_reel";

export interface SimulationComparaisonYearComparisonModel {
  annee_index: number;
  annee_label: string;
  annee: number;
  meilleur_regime: SimulationComparaisonRegimeKey;
  tri: number;
}

export interface SimulationComparaisonSwitchInsightModel {
  message: string;
  premiere_annee_index: number | null;
  premiere_annee_label: string | null;
  regime_initial: SimulationComparaisonRegimeKey | null;
  nouveau_regime: SimulationComparaisonRegimeKey | null;
}

export interface SimulationComparaisonResultModel {
  annee: number;
  commun: {
    recettes: number;
    rendement_brut: number;
    charges_exploitation: number;
    resultat_brut: number;
    rendement_net: number;
    charges_financieres: number;
    capital_rembourse: number;
    cashflow_avant_impot: number;
  };
  regimes: {
    lmnp_reel: RegimeResultModel;
    lmnp_micro: RegimeResultModel;
    nu_reel: RegimeResultModel;
  };
  tri: number;
  meilleur_regime: SimulationComparaisonRegimeKey;
  comparaisons_par_annee: SimulationComparaisonYearComparisonModel[];
  bascule_regime: SimulationComparaisonSwitchInsightModel | null;
}

export interface SimulationComparaisonFormModel {
  email: string;
  firstName: string;
  source: string;
  consent: boolean;
  prixAchat: string;
  loyerAnnuel: string;
  slugParameter: "resident" | "non-resident";
  anneeIndex: string;
  expertComptable: boolean;
  courtier: boolean;
  chasseurImmobilier: boolean;
  honeypot: string;
}

export function getInitialSimulationComparaisonFormStep(): SimulationComparaisonFormStep {
  return SIMULATION_COMPARAISON_FORM_STEPS[0];
}

export function getNextSimulationComparaisonFormStep(
  currentStep: SimulationComparaisonFormStep,
): SimulationComparaisonFormStep {
  switch (currentStep) {
    case "intro":
      return "bien";
    case "bien":
      return "options";
    case "options":
      return "contact";
    case "contact":
      return "result";
    case "result":
      return "result";
    default:
      return currentStep;
  }
}

export function getPreviousSimulationComparaisonFormStep(
  currentStep: SimulationComparaisonFormStep,
): SimulationComparaisonFormStep {
  switch (currentStep) {
    case "bien":
      return "intro";
    case "options":
      return "bien";
    case "contact":
      return "options";
    case "result":
      return "contact";
    default:
      return currentStep;
  }
}

export function getSimulationComparaisonFormProgress(
  currentStep: SimulationComparaisonFormStep,
): { current: number; total: number } {
  switch (currentStep) {
    case "intro":
      return { current: 0, total: 4 };
    case "bien":
      return { current: 1, total: 4 };
    case "options":
      return { current: 2, total: 4 };
    case "contact":
      return { current: 3, total: 4 };
    case "result":
      return { current: 4, total: 4 };
    default:
      return { current: 0, total: 4 };
  }
}
